<template>
  <div class="edit list-panel">
    <div class="main-container">
      <div class="content-wrap">
        <delivery-form operate-type="show"></delivery-form>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryForm from "./component/form";
export default {
  components: {
    DeliveryForm
  }
}
</script>